<script>
import {supabase} from "./supabaseClient"
import router from 'page'

import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"

let email =  new URLSearchParams(window.location.search).get('email');
let password;
let confirmPassword;
let displayError='';



const handleResetPassword = async () => {
  let errorMessage = ''
  if (password != confirmPassword) errorMessage += 'Both passwords must match'

  if (errorMessage != ''){
    displayError = errorMessage
    return;
  }

  const {
  data: { user },
  error,
  } = await supabase.auth.updateUser({
    email: email,
    password: password
  })
  // const { user, error } = await supabase.auth.update({
  //   email: email,
  //   password: password
  // })
  if (error) {
    console.log(error)
    displayError = error.message
  } else {
    router.redirect('/myboards')
}
}


</script>
<StandardHeader />

<div style="display:flex; flex-direction: column; height: 100%; margin-left: auto; margin-right: auto; min-width:300px; max-width:300px; margin-top: auto;margin-top: 10%">
<div><b>Reset Password</b></div>
  <form on:submit|preventDefault={handleResetPassword} id="ResetPassword">

    <div class="space-y-4">
      <input
        type="email"
        placeholder="Email"
        bind:value={email}
        class="input input-bordered w-full"
      />
    
      <input
        type="password"
        placeholder="New Password"
        bind:value={password}
        on:input={() => displayError = ''}
        class="input input-bordered w-full"
      />
    
      <input
        type="password"
        placeholder="Confirm New Password"
        bind:value={confirmPassword}
        on:input={() => displayError = ''}
        class="input input-bordered w-full"
      />
    
      {#if displayError}
        <div class="text-red-600 text-sm">{displayError}</div>
      {/if}
    
      <div class="flex justify-end">
        <button type="submit" class="btn bg-[var(--aqua)] text-white hover:opacity-90">
          Reset Password
        </button>
      </div>
    </div>
    

    <!-- <div><input placeholder="Email" bind:value={email} style="width:100%"/> </div>
    <div><input on:input={() => displayError=''} placeholder="New Password" type="password" bind:value={password} style="width:100%"/> </div>
    <div><input on:input={() => displayError=''} placeholder="Confirm New Password" type="password" bind:value={confirmPassword} style="width:100%"/> </div>
    <div style="color:red">{displayError}</div>
     -->
    <!-- <div><button class="primary" style="float:right" type="submit">Reset Password</button> </div> -->
  </form>
</div>

<StandardFooter />
